const {setTimeout} = globalThis;

class LoaderAdapter
{
    /** Der Standard-Adapter für alle Loader, die das {@link Loadable|Loadable-Mixin} implementieren.
     */
    constructor(loader, collection)
    {
        this._loader = loader;
        this._collection = collection;
        this.init();
    }

    get loader()
    {
        return this._loader;
    }

    init()
    {
        const initHandler = () =>
        {
            if (this.isLoaded())
            {
                this._collection.completeLoad();
            }
            else
            {
                this.addEventListener();
                this._updateProgress();
            }
        };

        // Verhindert diverse Probleme beim Hinzufügen mehrerer Adapter in eine Collection, von denen einer bereits
        // fertig geladen ist.
        setTimeout(initHandler, 1);
    }

    _complete()
    {
        this._collection.completeLoad();
        this.removeEventListener();
    }

    _updateProgress()
    {
        this._collection._updateProgress();
    }

    addEventListener()
    {
        this._loader.on('load', this._updateProgress, {scope: this});
        this._loader.on('loaded', this._complete, {scope: this});
    }

    removeEventListener()
    {
        this._loader.off('load', this._updateProgress);
        this._loader.off('loaded', this._complete);
    }

    destroy()
    {
        this.removeEventListener();
        this._loader.cancelLoading();
    }

    getProgress()
    {
        return this._loader.getLoadProgress();
    }

    isLoaded()
    {
        return this._loader.isLoaded();
    }
}

export default LoaderAdapter;
